<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  name: {
    type: String,
    default: '',
  },
});

</script>

<template>
  <span class="text-red-600"
        :title="props.name ? `${props.name} is required` : 'This input is required'">*</span>
</template>